
const ElectronicBilling = () =>
    import("@/views/electronicBilling/ElectronicBilling");

export const ElectronicBillingRoute = {
    path: "/electronicBilling",
    component: ElectronicBilling,
    meta: {
        requiresAuth: true,
        title: "message.ecommerce",
        scope:["aps_broker","aps_executive"],
        breadcrumb: [
        {
            text: "",
            disabled: false,
            href: "#"
        }]
    }
};